import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import CookieConsent from "@/components/CookieConsent";
import Home from "@/pages/Home";
import ManagedServices from "@/pages/ManagedServices";
import InfrastructureITOperations from "@/pages/InfrastructureITOperations";
import OracleAMS from "@/pages/OracleAMS";
import MicrosoftWorkplaceSupport from "@/pages/MicrosoftWorkplaceSupport";
import StaffAugmentation from "@/pages/StaffAugmentation";
import BusinessConsulting from "@/pages/BusinessConsulting";
import CapitalProjects from "@/pages/CapitalProjects";
import About from "@/pages/About";
import Resources from "@/pages/Resources";
import CaseStudyDetail from "@/pages/CaseStudyDetail";
import BlogPostDetail from "@/pages/BlogPostDetail";
import Careers from "@/pages/Careers";
import JobDetail from "@/pages/JobDetail";
import AdminLogin from "@/pages/AdminLogin";
import AdminJobs from "@/pages/AdminJobs";
import Contact from "@/pages/Contact";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsOfService from "@/pages/TermsOfService";
import { Toaster } from "@/components/ui/toaster";

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services/managed-services" element={<ManagedServices />} />
            <Route path="/services/managed-services/infrastructure-it-operations" element={<InfrastructureITOperations />} />
            <Route path="/services/managed-services/oracle-ams" element={<OracleAMS />} />
            <Route path="/services/managed-services/microsoft-workplace-support" element={<MicrosoftWorkplaceSupport />} />
            <Route path="/services/staff-augmentation" element={<StaffAugmentation />} />
            <Route path="/services/business-consulting" element={<BusinessConsulting />} />
            <Route path="/capital-projects" element={<CapitalProjects />} />
            <Route path="/about" element={<About />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/case-studies/:slug" element={<CaseStudyDetail />} />
            <Route path="/resources/case-studies/:slug" element={<CaseStudyDetail />} />
            <Route path="/blog/:slug" element={<BlogPostDetail />} />
            <Route path="/resources/blog/:slug" element={<BlogPostDetail />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/careers/:jobId" element={<JobDetail />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/jobs" element={<AdminJobs />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />
          </Routes>
          <Footer />
          <CookieConsent />
          <Toaster />
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
